import { createFileRoute } from "@tanstack/react-router";
import TodoParaTuComercio from "@/pages/TodoParaTuComercio";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/everything-for-your-store")({
  head: () => pageHead("everythingForShop", "en", { links: false }),
  component: TodoParaTuComercio,
});
